import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IDeletePermissionButton {
  permissionId: number;
  studentId: number;
}

const CustomConfirmButton = ({
  permissionId,
  studentId,
}: IDeletePermissionButton) => {
  const notify = useNotify();

  const [handleDeletePermission, { loading }] = useMutation(
    {
      type: "customDelete",
      resource: `students/${studentId}/permissions/${permissionId}`,
      payload: { id: permissionId },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully delete the permission.`, "info");
        window.location.reload();
      },
      onFailure: (error) =>
        notify(
          `Failed delete the permission, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleDeletePermission}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const DeletePermission = ({
  permissionId,
  studentId,
}: IDeletePermissionButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={`Delete Permission`}
        onClick={handleOpenDialog}
        style={{ backgroundColor: "#f44336" }}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Delete Permission</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure to Delete the permission ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton
            permissionId={permissionId}
            studentId={studentId}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DeletePermission;
